import { omniAtom } from "src/utils/atoms";

import { ConfirmModalProps } from "./types";

export const confirmModalDataAtom = omniAtom({
  key: "modalConfirm",
  value: null as ConfirmModalProps | null,
});
